module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/reg-login-6775aedf49f8cfae49269c8aba8791fd.svg";